// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"03ae9052","677":"d962f71f","930":"09b58e0c"}[chunkId] + ".chunk.js";
};